(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-vcc-lsmf-root]';
  var DISCLOSURE_SELECTOR = '[data-vcc-lsmf-disclosure]';
  var PANEL_SELECTOR = '[data-vcc-lsmf-panel]';
  var SEGMENT_SELECTOR = '[data-vcc-lsmf-segment]';
  var MENU_ROW_SELECTOR = '[data-vcc-lsmf-menu-link], [data-vcc-lsmf-group-link]';

  if (window.__vccLiquidSpectrumMainFourBootstrapped) return;
  window.__vccLiquidSpectrumMainFourBootstrapped = true;

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function containsRoot(scope, root) {
    return scope === root || (scope && typeof scope.contains === 'function' && scope.contains(root));
  }

  function rootsWithin(scope) {
    var roots = [];
    var searchRoot = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    if (scope && typeof scope.matches === 'function' && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    toArray(searchRoot.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });

    return roots;
  }

  function Controller(root) {
    this.root = root;
    this.sectionWrapper = root.closest('.shopify-section');
    this.rail = root.querySelector('[data-vcc-lsmf-rail]');
    this.disclosures = toArray(root.querySelectorAll(DISCLOSURE_SELECTOR));
    this.panels = toArray(root.querySelectorAll(PANEL_SELECTOR));
    this.openButton = null;
    this.closeTimer = 0;
    this.resizeFrame = 0;
    this.touchTimers = [];
    this.lastPointerType = '';
    this.lastPointerAt = 0;
    this.abortController = new AbortController();
    this.resizeObserver = null;

    this.root.setAttribute('data-vcc-lsmf-embedded-preview', this.isEmbeddedPreview() ? 'true' : 'false');
    this.root.setAttribute('data-vcc-lsmf-protected-webview', this.isProtectedWebView() ? 'true' : 'false');

    this.bind();
    this.closeAll(false);
    this.positionOpenPanel();
  }

  Controller.prototype.listen = function (target, eventName, handler, options) {
    var config = options || {};
    config.signal = this.abortController.signal;
    target.addEventListener(eventName, handler, config);
  };

  Controller.prototype.isFineHover = function () {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  };

  Controller.prototype.isMobile = function () {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  };

  Controller.prototype.isEmbeddedPreview = function () {
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    var framed = false;
    try {
      framed = window.self !== window.top;
    } catch (error) {
      framed = true;
    }
    return designMode || framed || this.isProtectedWebView();
  };

  Controller.prototype.isProtectedWebView = function () {
    var userAgent = typeof navigator === 'object' ? String(navigator.userAgent || '') : '';
    return /\b(?:FBAN|FBAV|FB_IAB|FBIOS|Instagram|Line|LIFF|Shopify|MicroMessenger)\b|NAVER\(inapp|;\s*wv\b|\bWebView\b/i.test(userAgent);
  };

  Controller.prototype.recentPointerType = function () {
    var age = Date.now() - this.lastPointerAt;
    if (!this.lastPointerType || age < 0 || age >= 1500) return '';
    return this.lastPointerType;
  };

  Controller.prototype.isTouchActivation = function (event) {
    if (event && event.detail === 0) return false;

    var recentPointerType = this.recentPointerType();
    if (recentPointerType) return recentPointerType !== 'mouse';

    return Boolean(!this.isFineHover() && event && event.detail > 0);
  };

  Controller.prototype.setPointerPool = function (element, event, xProperty, yProperty) {
    if (!element) return;
    var bounds = element.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    var x = Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100));
    var y = Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100));
    element.style.setProperty(xProperty, x.toFixed(2) + '%');
    element.style.setProperty(yProperty, y.toFixed(2) + '%');
  };

  Controller.prototype.activateTouch = function (element) {
    var self = this;
    if (!element) return;

    element.classList.remove('is-touch-active');
    void element.offsetWidth;
    element.classList.add('is-touch-active');

    var duration = Number(this.root.getAttribute('data-vcc-lsmf-touch-duration')) || 360;
    var timer = window.setTimeout(function () {
      element.classList.remove('is-touch-active');
      self.touchTimers = self.touchTimers.filter(function (activeTimer) { return activeTimer !== timer; });
    }, duration);
    this.touchTimers.push(timer);
  };

  Controller.prototype.clearTouchFeedback = function () {
    this.touchTimers.forEach(function (timer) { window.clearTimeout(timer); });
    this.touchTimers = [];
    toArray(this.root.querySelectorAll('.is-touch-active')).forEach(function (element) {
      element.classList.remove('is-touch-active');
    });
  };

  Controller.prototype.prepareForNavigation = function () {
    this.cancelClose();
    this.clearTouchFeedback();
    this.closeAll(false);
    this.root.setAttribute('data-vcc-lsmf-navigating', 'true');
  };

  Controller.prototype.resetAfterNavigation = function () {
    this.root.removeAttribute('data-vcc-lsmf-navigating');
    this.clearTouchFeedback();
    this.closeAll(false);
  };

  Controller.prototype.bind = function () {
    var self = this;

    this.listen(this.root, 'click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var activationSegment = target.closest(SEGMENT_SELECTOR);
      var touchActivation = self.isTouchActivation(event);
      var unmodifiedPointerActivation = Boolean(
        event.detail > 0 &&
        !event.altKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey
      );
      if (activationSegment && self.root.contains(activationSegment) && (touchActivation || unmodifiedPointerActivation)) {
        var segmentDisclosure = activationSegment.querySelector(DISCLOSURE_SELECTOR);
        if (segmentDisclosure) {
          event.preventDefault();
          self.cancelClose();
          if (touchActivation) {
            self.root.setAttribute('data-vcc-lsmf-touch-input', 'true');
            if (!self.recentPointerType()) self.activateTouch(activationSegment);
          }
          if (segmentDisclosure.getAttribute('aria-expanded') !== 'true') self.openPanel(segmentDisclosure);
          return;
        }
      }

      var disclosure = target.closest(DISCLOSURE_SELECTOR);
      if (disclosure && self.root.contains(disclosure)) {
        event.preventDefault();
        self.cancelClose();
        if (disclosure.getAttribute('aria-expanded') === 'true') {
          self.closePanel(disclosure, event.detail === 0);
        } else {
          self.openPanel(disclosure);
        }
        return;
      }

      var closeControl = target.closest('[data-vcc-lsmf-close]');
      if (closeControl && self.root.contains(closeControl)) {
        event.preventDefault();
        self.closeCurrent(event.detail === 0);
        return;
      }

      var panelLink = target.closest(PANEL_SELECTOR + ' a');
      if (panelLink && self.root.contains(panelLink)) {
        self.clearTouchFeedback();
        self.closeCurrent(false);
      }
    });

    this.listen(this.root, 'keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (!(target instanceof Element)) return;
      var disclosure = target.closest(DISCLOSURE_SELECTOR);
      if (!disclosure || !self.root.contains(disclosure)) return;
      event.preventDefault();
      disclosure.click();
    });

    this.listen(this.root, 'pointermove', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var target = event.target;
      if (!(target instanceof Element)) return;

      var menuRow = target.closest(MENU_ROW_SELECTOR);
      if (menuRow && self.root.contains(menuRow)) {
        self.setPointerPool(menuRow, event, '--vcc-lsmf-row-pool-x', '--vcc-lsmf-row-pool-y');
      }

      var segment = target.closest(SEGMENT_SELECTOR);
      if (!segment || !self.root.contains(segment)) return;
      self.setPointerPool(segment, event, '--vcc-lsmf-pool-x', '--vcc-lsmf-pool-y');
    });

    this.listen(this.root, 'pointerdown', function (event) {
      self.lastPointerType = event.pointerType || '';
      self.lastPointerAt = Date.now();
      if (event.pointerType) {
        self.root.setAttribute('data-vcc-lsmf-touch-input', event.pointerType === 'mouse' ? 'false' : 'true');
      }
      if (!event.pointerType || event.pointerType === 'mouse') return;
      var target = event.target;
      if (!(target instanceof Element)) return;

      var menuRow = target.closest(MENU_ROW_SELECTOR);
      if (menuRow && self.root.contains(menuRow)) {
        self.setPointerPool(menuRow, event, '--vcc-lsmf-row-pool-x', '--vcc-lsmf-row-pool-y');
        self.activateTouch(menuRow);
      }

      var segment = target.closest(SEGMENT_SELECTOR);
      if (!segment || !self.root.contains(segment)) return;
      self.setPointerPool(segment, event, '--vcc-lsmf-pool-x', '--vcc-lsmf-pool-y');
      self.activateTouch(segment);
    });

    toArray(this.root.querySelectorAll(SEGMENT_SELECTOR)).forEach(function (segment) {
      var disclosure = segment.querySelector(DISCLOSURE_SELECTOR);
      if (!disclosure) return;

      self.listen(segment, 'pointerenter', function () {
        if (!self.isFineHover() || self.root.getAttribute('data-vcc-lsmf-open-behavior') !== 'hover_click') return;
        self.cancelClose();
        self.openPanel(disclosure);
      });

      self.listen(segment, 'pointerleave', function () {
        if (!self.isFineHover() || self.root.getAttribute('data-vcc-lsmf-open-behavior') !== 'hover_click') return;
        self.scheduleClose();
      });
    });

    this.panels.forEach(function (panel) {
      self.listen(panel, 'pointerenter', function () {
        if (self.isFineHover()) self.cancelClose();
      });

      self.listen(panel, 'pointerleave', function () {
        if (self.isFineHover() && self.root.getAttribute('data-vcc-lsmf-open-behavior') === 'hover_click') {
          self.scheduleClose();
        }
      });
    });

    this.listen(document, 'pointerdown', function (event) {
      if (!self.openButton || self.root.contains(event.target)) return;
      self.closeCurrent(false);
    });

    this.listen(document, 'keydown', function (event) {
      if (event.key !== 'Escape' || !self.openButton) return;
      event.preventDefault();
      self.closeCurrent(true);
    });

    this.listen(window, 'resize', function () {
      if (self.resizeFrame) window.cancelAnimationFrame(self.resizeFrame);
      self.resizeFrame = window.requestAnimationFrame(function () {
        self.resizeFrame = 0;
        self.positionOpenPanel();
      });
    }, { passive: true });

    this.listen(window, 'pagehide', function () {
      self.prepareForNavigation();
    }, { capture: true });

    this.listen(window, 'pageshow', function (event) {
      if (event.persisted || self.root.hasAttribute('data-vcc-lsmf-navigating')) {
        self.resetAfterNavigation();
      }
    });

    if ('ResizeObserver' in window && this.rail) {
      this.resizeObserver = new ResizeObserver(function () {
        self.positionOpenPanel();
      });
      this.resizeObserver.observe(this.rail);
    }
  };

  Controller.prototype.panelFor = function (disclosure) {
    var panelId = disclosure && disclosure.getAttribute('aria-controls');
    if (!panelId) return null;
    return this.root.querySelector('#' + CSS.escape(panelId));
  };

  Controller.prototype.openPanel = function (disclosure) {
    var panel = this.panelFor(disclosure);
    if (!panel) return;

    this.root.removeAttribute('data-vcc-lsmf-navigating');
    if (this.openButton && this.openButton !== disclosure) this.closePanel(this.openButton, false);
    this.cancelClose();

    disclosure.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.classList.add('is-open');

    var segment = disclosure.closest(SEGMENT_SELECTOR);
    if (segment) segment.classList.add('is-open');

    this.openButton = disclosure;
    this.root.setAttribute('data-vcc-lsmf-open-category', disclosure.getAttribute('data-vcc-lsmf-category') || '');
    if (this.sectionWrapper) this.sectionWrapper.classList.add('vcc-lsmf-section-open');
    this.positionPanel(panel, disclosure);
  };

  Controller.prototype.closePanel = function (disclosure, restoreFocus) {
    var panel = this.panelFor(disclosure);
    disclosure.setAttribute('aria-expanded', 'false');

    var segment = disclosure.closest(SEGMENT_SELECTOR);
    var activeElement = document.activeElement;
    var releaseClosedFocus = Boolean(
      !restoreFocus &&
      activeElement &&
      typeof activeElement.blur === 'function' &&
      ((segment && segment.contains(activeElement)) || (panel && panel.contains(activeElement)))
    );

    if (segment) {
      segment.classList.remove('is-open');
      segment.classList.remove('is-touch-active');
    }

    if (releaseClosedFocus) activeElement.blur();

    if (panel) {
      panel.classList.remove('is-open');
      panel.hidden = true;
    }

    if (this.openButton === disclosure) {
      this.openButton = null;
      this.root.removeAttribute('data-vcc-lsmf-open-category');
      if (this.sectionWrapper) this.sectionWrapper.classList.remove('vcc-lsmf-section-open');
    }

    if (restoreFocus && disclosure.isConnected) {
      try {
        disclosure.focus({ preventScroll: true });
      } catch (error) {
        disclosure.focus();
      }
    }
  };

  Controller.prototype.closeCurrent = function (restoreFocus) {
    this.cancelClose();
    if (this.openButton) this.closePanel(this.openButton, restoreFocus);
  };

  Controller.prototype.closeAll = function (restoreFocus) {
    var self = this;
    this.disclosures.forEach(function (disclosure) {
      self.closePanel(disclosure, Boolean(restoreFocus && self.openButton === disclosure));
    });
    this.openButton = null;
    this.root.removeAttribute('data-vcc-lsmf-open-category');
    if (this.sectionWrapper) this.sectionWrapper.classList.remove('vcc-lsmf-section-open');
  };

  Controller.prototype.scheduleClose = function () {
    var self = this;
    this.cancelClose();
    var delay = Number(this.root.getAttribute('data-vcc-lsmf-close-delay')) || 0;
    this.closeTimer = window.setTimeout(function () {
      self.closeTimer = 0;
      if (self.root.matches(':hover') || self.root.contains(document.activeElement)) return;
      self.closeCurrent(false);
    }, delay);
  };

  Controller.prototype.cancelClose = function () {
    if (!this.closeTimer) return;
    window.clearTimeout(this.closeTimer);
    this.closeTimer = 0;
  };

  Controller.prototype.positionPanel = function (panel, disclosure) {
    if (!panel || !disclosure) return;

    if (this.root.getAttribute('data-vcc-lsmf-overlay') !== 'true') {
      panel.style.removeProperty('--vcc-lsmf-panel-left-quarter');
      panel.style.removeProperty('--vcc-lsmf-panel-span');
      return;
    }

    var mobile = this.isMobile();
    var spanAttribute = mobile ? 'data-vcc-lsmf-mobile-span' : 'data-vcc-lsmf-desktop-span';
    var span = Number(this.root.getAttribute(spanAttribute)) || 4;
    var mobileColumns = Number(this.root.getAttribute('data-vcc-lsmf-mobile-menu-columns')) || 1;
    var minimumSpan = mobile ? (mobileColumns === 2 ? 3 : 2) : 1;
    span = Math.max(minimumSpan, Math.min(4, span));

    var sourceIndex = Number(disclosure.getAttribute('data-vcc-lsmf-source-index')) || 0;
    var leftQuarter = Math.max(0, Math.min(sourceIndex, 4 - span));
    panel.style.setProperty('--vcc-lsmf-panel-left-quarter', String(leftQuarter));
    panel.style.setProperty('--vcc-lsmf-panel-span', String(span));
  };

  Controller.prototype.positionOpenPanel = function () {
    if (!this.openButton) return;
    this.positionPanel(this.panelFor(this.openButton), this.openButton);
  };

  Controller.prototype.destroy = function () {
    this.cancelClose();
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = 0;
    this.clearTouchFeedback();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.resizeObserver = null;
    this.closeAll(false);
    this.abortController.abort();
    this.root.removeAttribute('data-vcc-lsmf-initialized');
    delete this.root.__vccLsmfController;
  };

  function initialize(root) {
    if (!root || root.__vccLsmfController) return;
    root.__vccLsmfController = new Controller(root);
    root.setAttribute('data-vcc-lsmf-initialized', 'true');
  }

  function initializeAll(scope) {
    rootsWithin(scope).forEach(initialize);
  }

  function destroyAll(scope) {
    rootsWithin(scope).forEach(function (root) {
      if (!containsRoot(scope, root) || !root.__vccLsmfController) return;
      root.__vccLsmfController.destroy();
    });
  }

  function ready() {
    initializeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    rootsWithin(event.target || document).forEach(function (root) {
      if (root.__vccLsmfController) root.__vccLsmfController.positionOpenPanel();
    });
  });
})();
